"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Discount_1 = require("./Discount");
var core_1 = require("@material-ui/core");
var discountListStyles_1 = require("./discountListStyles");
var DiscountsList = function (_a) {
    var currency = _a.currency, discounts = _a.discounts;
    var styles = discountListStyles_1.default();
    return (<core_1.Box className={styles.container}>
      {discounts.map(function (discount) { return (<Discount_1.default key={discount.code} id={discount.code} currency={currency} discount={discount} label={discount.label} boldLabel={false} boldPrice={false}/>); })}
    </core_1.Box>);
};
exports.default = DiscountsList;
